import React from 'react';
import { Table as AntTable, Space, Avatar, Popconfirm,Input ,Button, Modal } from 'antd';
import { useState,useRef } from "react";
import { UserOutlined,SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
};

const Table = ({ data, onEdit, onDelete, loading, onAssign, onViewDetails, isAllCases = false }) => {
  const { currentColor } = useStateContext();
  const [ setSearchText] = useState('');
  const [ setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    { 
      title: 'ลำดับ',
      align: 'center',  
      width: 60, 
      dataIndex: 'number',
      key: 'number',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    { 
      title: 'CaseName', 
      align: 'center', 
      dataIndex: 'caseName', 
      key: 'caseName',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (caseName) => {
        const getCaseNameColor = (caseName) => {
          switch (caseName) {
            case 'deposit':
              return 'green';
            case 'withdraw':
              return 'red';
            case 'ETC':
              return 'purple';
            case 'Panel':
              return '#1677ff';
            case 'Register':
              return '#08979c';
            case 'transfer':
              return 'purple';
            default:
              return 'black';
          }
        };
        return <span style={{ fontSize: '16px',fontWeight: 'bold', color: getCaseNameColor(caseName) }}>{caseName.toUpperCase()}</span>;
      },
      ...getColumnSearchProps('caseName'),
    },
    { 
      title: 'UserId', 
      align: 'center', 
      dataIndex: 'userId', 
      key: 'userId',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (userId, record) => (
        <span>
          {record.isVIP && <span style={{ fontSize: '16px', color: 'gold' }}><FontAwesomeIcon icon={faCrown} /></span>} {userId?.toUpperCase()}
        </span>
      ),
      ...getColumnSearchProps('userId'),
    },
    { 
      title: 'Note', 
      align: 'center', 
      dataIndex: 'note', 
      key: 'note',
      onHeaderCell: () =>{return {style:headerStyle}},
      render: (note) => {
        if (!note || note === '-') return '-';
        return (
          <div style={{ 
            whiteSpace: 'pre-wrap', 
            textAlign: 'left',
            maxWidth: '200px',
            wordBreak: 'break-word'
          }}>
            {note}
          </div>
        );
      }
    },
    { 
      title: 'Status', 
      align: 'center', 
      dataIndex: 'status', 
      key: 'status',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (status) => {
        const getStatusColor = (status) => {
          switch (status) {
            case 'Success':
              return 'green'; // เหลืองส้ม
            case 'Reject':
              return 'red'; // bright red
            case 'Inform':
              return '#fa8c16'; // ส้ม — ขอข้อมูลเพิ่ม ไม่ใช่ความผิด
            case 'Pending':
              return '#ffa500'; // bright orange
            case 'Waiting':
              return 'blue'; // bright blue
            case 'Processing':
              return 'purple';
            default:
              return '#000000'; // black
          }
        };

        return (
          <span style={{ 
            color: getStatusColor(status),
            // fontWeight: 'bold',
            fontSize: '16px',
            //backgroundColor: getStatusColor(status),
          }}>
            <span style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: getStatusColor(status),
              marginRight: '4px',
            }}></span>
            {status || "-"}
            <span style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: getStatusColor(status),
              marginLeft: '4px',
            }}></span>
          </span>
        );
      },
    },
    
    {
      title: 'Pending Remark',
      dataIndex: 'pending_remark',
      key: 'pending_remark',
      align: 'center',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (remark, record) => (
        record.status === 'Pending' ? (
          <Button
            size="small"
            onClick={() => {
              Modal.info({
                title: 'Pending Remark',
                content: (
                  <div style={{ maxWidth: 400, wordBreak: 'break-word' }}>
                    {remark ? remark : 'ไม่มีข้อมูล'}
                  </div>
                ),
                okText: 'ปิด',
              });
            }}
          >
            ดูข้อความ
          </Button>
        ) : null
      ),
    },
    {
      title: 'วันที่อัพเดตล่าสุด',
      dataIndex: 'lastUpdateDate',
      key: 'lastUpdateDate',
      align: 'center',
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          {isAllCases ? (
            <>
              <Button 
                type="default"
                onClick={() => onViewDetails(record)}
              >
                ดูรายละเอียด
              </Button>
              <Button 
                type="primary"
                onClick={() => onAssign(record)}
              >
                เพิ่มงาน
              </Button>
            </>
          ) : (
            <Button 
              type="primary"
              onClick={() => onEdit(record)}
            >
              จัดการ
            </Button>
          )}
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return ( 
    <div className='overflow-x-auto'>
      <AntTable 
        loading={loading}   
        className='border-1 rounded-lg border-gray-200' 
        dataSource={genNumberTable(data)}
        columns={columns}  
        //pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}  
      />
    </div>
  );
};

export default Table;
